import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import BootstrapVue from 'bootstrap-vue'
import VuePageTransition from 'vue-page-transition'
import rate from 'vue-rate'
import CheckboxRadio from 'vue-checkbox-radio'
import moment from 'moment'
import VueTouchKeyboard from 'vue-touch-keyboard'
import 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import VeeValidate from 'vee-validate';

Vue.config.productionTip = false

Vue.use(VueTouchKeyboard)
Vue.use(VuePageTransition)
Vue.use(CheckboxRadio)
Vue.use(BootstrapVue)
Vue.use(rate)
Vue.use(VeeValidate);

require('moment/locale/id')
Vue.use(require('vue-moment'), {
  moment
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
